<template>
  <div>
    <a-row class="content-fix org">
      <a-row class="content-title" type="flex">
        <a-button type="primary" class="back-btn" @click="goBack()">

          <i class="t-transition icons icon-chevron-left" />
          Назад
        </a-button>
        <a-row class="post-search" type="flex">
          <a-select
            class="table__parpage"
            option-filter-prop="children"
            placeholder="Все"
          >
            <a-select-option
              
              v-for="(item, index) in generalStatistics.data"
              :key="index"
              :value="item.period_type"
            >

              {{ item.period_type }}
            </a-select-option>
          </a-select>

          <a-button type="primary" class="all-news-btn" style="margin: 0 15px">
            Все
          </a-button>

          <a-button
            style="margin: 0 15px"
            type="primary"
            @click="
              $router.push({
                name: 'mtms-general-create'
              })
            "
          >
            <a-icon type="plus" />{{ $t("Add") }}
          </a-button>
        </a-row>
      </a-row>

      <a-table
        v-if="!loading"
        :columns="columns"
        :data-source="generalStatistics.data"
        :spinning="loading"
        row-key="id"
      >

        <!-- year column -->
        <div slot="title" slot-scope="item" style="cursor: pointer">
          {{ item.title }}
        </div>
        <div slot="period_type" slot-scope="item" style="cursor: pointer">
          {{ item.period_type }}
        </div>
        <div slot="quarter" slot-scope="item" style="cursor: pointer">
          {{ item.quarter }}
        </div>
        <div slot="publication_date" slot-scope="item" style="cursor: pointer">
          {{ item.publication_date }}
        </div>

        <template slot="operation" slot-scope="item">
          <div class="action">
            <a-button
              class="edit-btn"
              type="primary"
              @click="
                $router.push(
                  {
                    name: 'mtms-general-detail',
                    params: { id: item.id }
                  },
                  () => null
                )
              "
            >

              <a-icon class="action-btns" type="edit" />
            </a-button>

            <a-button type="danger" @click="removeItem(item.id)">
              <a-icon class="action-btns" type="delete" />
            </a-button>
          </div>
        </template>
      </a-table>
    </a-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "Title",
          scopedSlots: { customRender: "title" }
        },
        {
          title: "Period Type",
          scopedSlots: { customRender: "period_type" }
        },
        {
          title: "Quarter",
          scopedSlots: { customRender: "quarter" }
        },
        {
          title: "Publication Date",
          scopedSlots: { customRender: "publication_date" }
        },
        {
          title: "Operation",
          scopedSlots: { customRender: "operation" }
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      generalStatistics: "mtms/generalStatistics",
      quarterlyStatistics: "mtms/quarterlyStatistics"
    })
  },

  async mounted() {
    this.loading = true
    const year = this.$route.params.year
    await this.getGeneralStat(year)

    this.loading = false
  },

  methods: {
    ...mapActions({

      getGeneralStat: "mtms/getGeneralStat"
    }),
    goBack() {
      this.$store.dispatch("mtms/resetStat")
      this.$router.push({ name: "mtms-year" })
    },
    async removeItem(id) {
      try {
        // Dispatch the Vuex action to delete the item
        const res = await this.$api.delete(
          `/admin/common/general-statistics/${id}`
        )


        // Check the API response and display appropriate feedback
        if (res && res.status === 204) {
          this.$message.success("Успешно удалено") // Success message
          this.loading = true
          const year = this.$route.params.year
          await this.getGeneralStat(year)

          this.loading = false
        } else {
          this.$message.error("Не удалось удалить элемент. Повторите попытку.") // Error message
        }
      } catch (error) {
        // Log and display an error notification
        console.error(`Error deleting item with ID ${id}:`, error)
        this.$message.error("Произошла ошибка при удалении элемента.")
      }
    }
  }
}
</script>

<style>
.wanted-search-input-wrapper {
  flex: 0 0 430px;
  justify-content: space-around;
}
</style>
